// Фиксирани списъци за падащите менюта
// (населените места са в data/settlements.json — вж. geo.ts)

export const HANDYMAN_SPECIALTIES = [
  'Електричество',
  'ВиК',
  'Боя и гипсокартон',
  'Ремонт на ел. уреди',
  'Климатици',
  'Ключар',
  'Дограма и остъкление',
  'Почистване',
] as const;

// Квартали/райони по град. Ползват се при добавяне на имот и за известията
// „свободен имот в района“ — затова са фиксиран списък, а не свободен текст:
// „Лозенец“, „лозенец“ и „кв. Лозенец“ иначе нямаше да съвпадат.
// Ако кварталът липсва в списъка, има опция „Друг (ръчно)“.
export const BG_DISTRICTS: Record<string, readonly string[]> = {
  София: [
    'Център', 'Лозенец', 'Младост', 'Люлин', 'Студентски град', 'Дружба', 'Надежда',
    'Овча купел', 'Красно село', 'Изток', 'Изгрев', 'Хиподрума', 'Гоце Делчев',
    'Стрелбище', 'Иван Вазов', 'Банишора', 'Обеля', 'Връбница', 'Слатина',
    'Подуяне', 'Сухата река', 'Хаджи Димитър', 'Редута', 'Гео Милев', 'Яворов',
    'Дианабад', 'Витоша', 'Бояна', 'Драгалевци', 'Симеоново', 'Манастирски ливади',
    'Крива река', 'Захарна фабрика', 'Разсадника', 'Илинден', 'Зона Б-5', 'Зона Б-18',
    'Триъгълника', 'Толстой', 'Свобода', 'Левски', 'Малинова долина', 'Мусагеница',
    'Малашевци', 'Факултета', 'Горубляне', 'Мл. Военно училище',
  ],
  Пловдив: [
    'Център', 'Капана', 'Стария град', 'Кършияка', 'Тракия', 'Смирненски',
    'Кючук Париж', 'Мараша', 'Каменица', 'Христо Ботев', 'Изгрев', 'Съдийски',
    'Гагарин', 'Остромила', 'Беломорски', 'Прослав', 'Коматево', 'Северен',
    'Западен', 'Южен', 'Източен', 'Филипово', 'Асеновградско шосе',
  ],
  Варна: [
    'Център', 'Гръцка махала', 'Чайка', 'Левски', 'Владислав Варненчик', 'Младост',
    'Аспарухово', 'Галата', 'Приморски', 'Бриз', 'Виница', 'Трошево', 'Възраждане',
    'Победа', 'Изгрев', 'Кайсиева градина', 'Св. Никола', 'Погребите', 'Морска градина',
    'Аспарухово-Дружба', 'Максуда', 'Колхозен пазар',
  ],
  Бургас: [
    'Център', 'Лазур', 'Славейков', 'Изгрев', 'Зорница', 'Меден рудник',
    'Възраждане', 'Братя Миладинови', 'Сарафово', 'Крайморие', 'Долно Езерово',
    'Горно Езерово', 'Ветрен', 'Банево', 'Победа', 'Акациите', 'Черно море',
  ],
  Русе: [
    'Център', 'Здравец', 'Дружба', 'Възраждане', 'Чародейка', 'Родина', 'Ялта',
    'Цветница', 'Мидия Енос', 'Веждата', 'Тракция', 'Долапите', 'Средна кула',
    'Басарбово', 'Новата махала',
  ],
  'Стара Загора': [
    'Център', 'Казански', 'Три чучура', 'Железник', 'Самара', 'Зора', '914',
    'Опълченски', 'Лозенец', 'Голеш', 'Кольо Ганчев', 'Индустриална зона',
    'Требенико', 'Богомилово',
  ],
  Плевен: [
    'Център', 'Широк център', 'Сторгозия', 'Дружба', 'Мара Денчева', 'Кайлъка',
    'Балкан', 'Варош', 'Двореца', 'Индустриална зона',
  ],
  Сливен: [
    'Център', 'Даме Груев', 'Дружба', 'Българка', 'Сини камъни', 'Клуцохор',
    'Речица', 'Ново село', 'Стоян Заимов', 'Индустриална зона',
  ],
  Добрич: [
    'Център', 'Дружба', 'Балик', 'Иглика', 'Русия', 'Строител', 'Добротица',
    'Възраждане', 'Рилци', 'Индустриална зона',
  ],
  Шумен: [
    'Център', 'Тракия', 'Боян Българанов', 'Добруджански', 'Херсон', 'Млада гвардия',
    'Дивдядово', 'Макак', 'Индустриална зона',
  ],
  Перник: [
    'Център', 'Изток', 'Тева', 'Мошино', 'Църква', 'Хумни дол', 'Бела вода',
    'Калкас', 'Драгановец', 'Караманица',
  ],
  Хасково: [
    'Център', 'Орфей', 'Овчарски', 'Каменни', 'Бадема', 'Куба', 'Хисаря',
    'Република', 'Македонски', 'Изгрев',
  ],
  Ямбол: [
    'Център', 'Граф Игнатиев', 'Диана', 'Златен рог', 'Възраждане', 'Каргон',
    'Хале', 'Бенковски', 'Индустриална зона',
  ],
  Пазарджик: [
    'Център', 'Устрем', 'Изток', 'Запад', 'Марица', 'Ставропол', 'Втори квартал',
    'Младост', 'Индустриална зона',
  ],
  Благоевград: [
    'Център', 'Еленово', 'Освобождение', 'Струмско', 'Вароша', 'Ален мак',
    'Запад', 'Грамада', 'Бялата висота',
  ],
  'Велико Търново': [
    'Център', 'Варуша', 'Асенов', 'Бузлуджа', 'Картала', 'Чолаковци', 'Зона Б',
    'Акация', 'Света гора', 'Триъгълника',
  ],
  Враца: [
    'Център', 'Дъбника', 'Медковец', 'Металург', 'Кулата', 'Сениче', 'Бистрец',
    'Индустриална зона',
  ],
  Габрово: [
    'Център', 'Младост', 'Трендафил', 'Бичкиня', 'Голо бърдо', 'Шиваров мост',
    'Велчевци', 'Индустриална зона',
  ],
  Асеновград: ['Център', 'Запад', 'Изток', 'Баделема', 'Горни воден', 'Долни воден', 'Металург'],
  Видин: ['Център', 'Крум Бъчваров', 'Гео Милев', 'Строител', 'Химик', 'Калето', 'Нов път'],
  Казанлък: ['Център', 'Изток', 'Запад', 'Васил Левски', 'Розова долина', 'Индустриална зона'],
  Кърджали: ['Център', 'Възрожденци', 'Гледка', 'Студен кладенец', 'Байкал', 'Веселчане'],
  Кюстендил: ['Център', 'Запад', 'Изток', 'Румена войвода', 'Герена', 'Осогово'],
  Монтана: ['Център', 'Младост', 'Пъстрина', 'Огоста', 'Плиска', 'Мала Кутловица'],
  Димитровград: ['Център', 'Изток', 'Марийно', 'Черноконево', 'Раковски', 'Вулкан'],
  Ловеч: ['Център', 'Вароша', 'Здравец', 'Дружба', 'Червен бряг', 'Продимчец'],
  Силистра: ['Център', 'Изток', 'Запад', 'Дунав', 'Деленки', 'Индустриална зона'],
  Разград: ['Център', 'Орел', 'Възраждане', 'Освобождение', 'Абритус', 'Индустриална зона'],
  Търговище: ['Център', 'Запад', 'Вароша', 'Бряг', 'Малчо Малчев', 'Индустриална зона'],
  Дупница: ['Център', 'Бистрица', 'Дружба', 'Аракчийски мост', 'Гиздова махала'],
  Смолян: ['Център', 'Райково', 'Устово', 'Невястата', 'Каптажа', 'Смолянски езера'],
  Петрич: ['Център', 'Изток', 'Запад', 'Самуилова крепост', 'Индустриална зона'],
  Сандански: ['Център', 'Спартак', 'Смилово', 'Изток', 'Промишлена зона'],
  Самоков: ['Център', 'Възраждане', 'Самоково', 'Ридо', 'Проучване'],
  'Горна Оряховица': ['Център', 'Гарата', 'Пролет', 'Калтинец', 'Индустриална зона'],
  Велинград: ['Център', 'Каменица', 'Чепино', 'Лъджене', 'Индустриална зона'],
};

export const OTHER_DISTRICT = 'Друг (ръчно)';

// Кварталите за град + опцията за ръчно въвеждане
export const districtsFor = (city: string): string[] => [
  ...(BG_DISTRICTS[city] ?? []),
  OTHER_DISTRICT,
];
